export type RecordingStatus = "Ready" | "Processing" | "Partial" | "Failed";
export type SegmentStatus = "Ready" | "Processing" | "Failed";
export type SortKey =
  | "date"
  | "startTime"
  | "patient"
  | "provider"
  | "segments"
  | "totalDuration"
  | "status";
export type SortDirection = "asc" | "desc";

export interface RecordingSegment {
  segmentNumber: number;
  start: Date | null;
  end: Date | null;
  durationMinutes: number;
  gapBeforeMinutes: number | null;
  status: SegmentStatus;
}

export interface ConsultationRecording {
  id: string;
  consultationId: string;
  patient: string;
  provider: string;
  providerType: string;
  status: RecordingStatus;
  start: Date | null;
  segmentCount: number;
  totalDurationMinutes: number;
  segments: RecordingSegment[];
}

export interface ConsultationRecordingProcessingState {
  id: string;
  status: RecordingStatus;
  segmentCount: number;
  totalDurationMinutes: number;
  stitchedAudioStatus: string;
  stitchedAudioPath: string;
  lastError: string;
  transcriptStatus: string;
  transcriptDeepgramRequestId: string;
  finalizationRetryCount: number;
  finalizationLastRetryAt: Date | null;
  finalizationLastError: string;
  finalizationLastStage: string;
  finalizationLastSignature: string;
}

export interface ConsultationRecordingTranscript {
  id: string;
  appointmentId: string;
  recordingId: string;
  status: string;
  finalTranscriptText: string | null;
  language: string | null;
  durationSeconds: number | null;
  lastError: string | null;
  createdAt: Date | null;
  updatedAt: Date | null;
}

export interface ConsultationRecordingListStats {
  totalRecordings: number;
  thisWeekCount: number;
  delta: number;
  averageDurationMinutes: number;
  failedCount: number;
}

export interface ConsultationRecordingListPagination {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

export interface ConsultationRecordingListResult {
  recordings: ConsultationRecording[];
  pagination: ConsultationRecordingListPagination;
  stats: ConsultationRecordingListStats;
}

export interface ConsultationRecordingProviderOption {
  id: string;
  name: string;
}

export const COLUMN_LABELS: Record<SortKey, string> = {
  date: "Date",
  startTime: "Start Time",
  patient: "Patient",
  provider: "Provider",
  segments: "Segments",
  totalDuration: "Total Duration",
  status: "Status",
};
